"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TD = exports.TDDecodeOption = exports.TDEncodeOption = void 0;
var _1 = require(".");
var _2 = require(".");
var LangUtil_1 = require("./core/LangUtil");
var TDEncodeOption = /** @class */ (function () {
    function TDEncodeOption(coderOption, jsonOption) {
        if (coderOption === void 0) { coderOption = new _2.TDObjectCoderOption(); }
        if (jsonOption === void 0) { jsonOption = new _1.TDJSONWriterOption(); }
        this.coderOption = coderOption;
        this.jsonOption = jsonOption;
    }
    TDEncodeOption.prototype.setCodeOption = function (codeOpt) {
        this.coderOption = codeOpt;
        return this;
    };
    TDEncodeOption.prototype.setJsonOption = function (jsonOpt) {
        this.jsonOption = jsonOpt;
        return this;
    };
    return TDEncodeOption;
}());
exports.TDEncodeOption = TDEncodeOption;
var TDDecodeOption = /** @class */ (function () {
    function TDDecodeOption() {
    }
    return TDDecodeOption;
}());
exports.TDDecodeOption = TDDecodeOption;
/**
 * A group of convenient methods similar to JSON
 */
var TD = /** @class */ (function () {
    function TD() {
    }
    TD.stringify = function (obj, opts) {
        if (opts === void 0) { opts = ''; }
        var opt = new TDEncodeOption();
        if (typeof opts === 'string')
            opt.jsonOption.setIndentStr(opts);
        else
            LangUtil_1.LangUtil.mergeDeep(opt, opts);
        return _1.TDJSONWriter.writeAsString(_1.TDObjectCoder.encode(obj, opt.coderOption), opt.jsonOption);
    };
    TD.parse = function (str, opts) {
        if (opts === void 0) { opts = {}; }
        return _1.TDJSONParser.get().parse(str, opts).toObject(false);
    };
    return TD;
}());
exports.TD = TD;
//# sourceMappingURL=TD.js.map